// extracted by mini-css-extract-plugin
export default {"list":"QRCodeListView_list__iqxA0"};